"use strict";

var _objectDestructuringEmpty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectDestructuringEmpty");

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteUser = exports.updateUser = exports.getUsers = exports.getUser = exports.getAuthUser = exports.addUser = void 0;

var _ = require(".");

var addUser = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, dispatch, config) {
    var siteID, email, role, result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            siteID = _ref.siteID, email = _ref.email, role = _ref.role;
            _context.next = 3;
            return (0, _.db)('createUser', {
              siteID: siteID,
              email: email,
              role: role
            }, dispatch, config);

          case 3:
            result = _context.sent;
            return _context.abrupt("return", result);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function addUser(_x, _x2, _x3) {
    return _ref7.apply(this, arguments);
  };
}();

exports.addUser = addUser;

var getAuthUser = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2, dispatch, config) {
    var result;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _objectDestructuringEmpty(_ref2);

            _context2.next = 3;
            return (0, _.db)('getAuthUser', {}, dispatch, config);

          case 3:
            result = _context2.sent;
            return _context2.abrupt("return", result);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getAuthUser(_x4, _x5, _x6) {
    return _ref8.apply(this, arguments);
  };
}();

exports.getAuthUser = getAuthUser;

var getUser = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref3, dispatch, config) {
    var siteID, id, result;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            siteID = _ref3.siteID, id = _ref3.id;
            _context3.next = 3;
            return (0, _.db)('getUser', {
              siteID: siteID,
              id: id
            }, dispatch, config);

          case 3:
            result = _context3.sent;
            return _context3.abrupt("return", result);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getUser(_x7, _x8, _x9) {
    return _ref9.apply(this, arguments);
  };
}();

exports.getUser = getUser;

var getUsers = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref4, dispatch, config) {
    var siteID, page, limit, result;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            siteID = _ref4.siteID, page = _ref4.page, limit = _ref4.limit;
            _context4.next = 3;
            return (0, _.db)('getUsers', {
              siteID: siteID,
              page: page,
              limit: limit
            }, dispatch, config);

          case 3:
            result = _context4.sent;
            return _context4.abrupt("return", result);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function getUsers(_x10, _x11, _x12) {
    return _ref10.apply(this, arguments);
  };
}();

exports.getUsers = getUsers;

var updateUser = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref5, dispatch, config) {
    var siteID, id, role, result;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            siteID = _ref5.siteID, id = _ref5.id, role = _ref5.role;
            _context5.next = 3;
            return (0, _.db)('updateUser', {
              siteID: siteID,
              id: id,
              role: role
            }, dispatch, config);

          case 3:
            result = _context5.sent;
            return _context5.abrupt("return", result);

          case 5:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function updateUser(_x13, _x14, _x15) {
    return _ref11.apply(this, arguments);
  };
}();

exports.updateUser = updateUser;

var deleteUser = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref6, dispatch, config) {
    var siteID, id, result;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            siteID = _ref6.siteID, id = _ref6.id;
            _context6.next = 3;
            return (0, _.db)('deleteUser', {
              siteID: siteID,
              id: id
            }, dispatch, config);

          case 3:
            result = _context6.sent;
            return _context6.abrupt("return", result);

          case 5:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function deleteUser(_x16, _x17, _x18) {
    return _ref12.apply(this, arguments);
  };
}();

exports.deleteUser = deleteUser;